import { createFileRoute } from '@tanstack/react-router';

import { InvoiceV2ImportPage } from '~/modules/invoice/v2';

import { i18n } from '~/utils';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

const title = i18n.t(($) => $.v2.import.pageTitle, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/v2/incoming/import/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/v2/incoming/import/',
    ...routeParams,
  }),
  component: InvoiceV2ImportPage,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
  wrapInSuspense: true,
});
